// extracted by mini-css-extract-plugin
export default {"backToLogin":"_aTAHUjytW_pleLEN3kQ"};